import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiGrid-item": {
      padding: 12,
    },
    "& .strength-chip": {
      width: 140,
      height: 40,
      margin: 0,
      justifyContent: "center",
      "& .MuiChip-label": {
        padding: "0 12px",
      },
    },
    "& .title-tag": {
      width: 156,
    },
    "& .description": {
      display: "flex",
      minHeight: 40,
      alignItems: "center",
    },
  },
  emptyState: {
    "& p": {
      marginTop: 16,
      color: "#C4C4C4",
    },
  },
}));
export default useStyles;
